
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/regions",
      function () {
        return require("private-next-pages/security/regions.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/regions"])
      });
    }
  